import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AnalyticsQuery, SnapshotResponse, DistributionResponse, TrendsResponse, GeoResponse, PerformanceResponse } from '../models/analytics.model';

@Injectable({
    providedIn: 'root',
})
export class RequestAnalyticsService {
    private baseUrl = `${environment.API_GATEWAY_URL}/request-v2/admin/analytics`;

    constructor(private http: HttpClient) {}

    getSnapshot(query: AnalyticsQuery): Observable<SnapshotResponse> {
        return this.http.get<SnapshotResponse>(`${this.baseUrl}/snapshot`, {
            params: this.buildParams(query),
        });
    }

    getDistribution(query: AnalyticsQuery): Observable<DistributionResponse> {
        return this.http.get<DistributionResponse>(`${this.baseUrl}/distribution`, {
            params: this.buildParams(query),
        });
    }

    getTrends(query: AnalyticsQuery): Observable<TrendsResponse> {
        return this.http.get<TrendsResponse>(`${this.baseUrl}/trends`, {
            params: this.buildParams(query),
        });
    }

    getPerformance(query: AnalyticsQuery): Observable<PerformanceResponse> {
        return this.http.get<PerformanceResponse>(`${this.baseUrl}/performance`, {
            params: this.buildParams(query),
        });
    }

    getGeo(query: AnalyticsQuery): Observable<GeoResponse> {
        return this.http.get<GeoResponse>(`${this.baseUrl}/geo`, {
            params: this.buildParams(query),
        });
    }

    private buildParams(query: AnalyticsQuery): HttpParams {
        let params = new HttpParams();

        if (query.period) {
            params = params.set('period', query.period);
        }
        if (query.from) {
            params = params.set('from', query.from);
        }
        if (query.to) {
            params = params.set('to', query.to);
        }
        if (query.comparePrevious) {
            params = params.set('comparePrevious', 'true');
        }
        if (query.departments && query.departments.length > 0) {
            query.departments.forEach((id) => {
                params = params.append('departments', id);
            });
        }

        return params;
    }
}
